export function canFieldBeRequired(field: FieldDto): boolean {
    return !field.is_read_only && field.type !== 'checkbox'
}

export function canFieldBeTruncated(field: FieldDto): boolean {
    return ['long_text', 'document'].includes(field.type)
}

export function canFieldBeRenderedAsImage(field: FieldDto): boolean {
    return ['multi_file', 'url', 'string'].includes(field.type)
}
